import { KeyValuePipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout';

import * as _ from 'lodash';

@Component({
  selector: 'badger-portal-theme-buddy',
  templateUrl: './theme-buddy.component.html',
  styleUrls: ['./theme-buddy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KeyValuePipe, LayoutAlignDirective, LayoutDirective, LayoutGapDirective, NgStyle]
})
export class ThemeBuddyComponent implements OnInit {
  themeData!: CustomThemeTokens;

  ngOnInit() {
    this.themeData = getThemeVariables();
  }
}

export interface CustomThemeTokens {
  system: Record<string, string>;
  extended: Record<string, string>;
  toast: Record<string, string>;
}

export function getThemeVariables(): CustomThemeTokens {
  const tokens: CustomThemeTokens = { system: {}, extended: {}, toast: {} };

  const rootStyles = window.getComputedStyle(document.documentElement);

  _.forEach(document.styleSheets, (styleSheet) => {
    try {
      const sheet = styleSheet;
      const rules = sheet.cssRules;

      _.forEach(rules, (rule) => {
        const styleRule = rule as CSSStyleRule;

        // Target rules that declare variables on :root or :host
        if (styleRule.selectorText && (styleRule.selectorText.includes(':styleRule') || styleRule.selectorText.includes(':host'))) {
          const style = styleRule.style;

          _.forEach(style, propName => {

            if (propName.startsWith('--sys-')) {
              tokens.system[propName] = rootStyles.getPropertyValue(propName).trim();
            }
            else if (propName.startsWith('--extended-')) {
              tokens.extended[propName] = rootStyles.getPropertyValue(propName).trim();
            }
            else if (propName.startsWith('--toast-')) {
              tokens.toast[propName] = rootStyles.getPropertyValue(propName).trim();
            }
          });
        }
      });
      // eslint-disable-next-line no-unused-vars
    } catch (exception) { /* intentionally empty */
    }
  });

  return tokens;
}
